import { render } from "./Trxs.vue?vue&type=template&id=068d10d2&scoped=true"
import script from "./Trxs.vue?vue&type=script&lang=js"
export * from "./Trxs.vue?vue&type=script&lang=js"

import "./Trxs.vue?vue&type=style&index=0&id=068d10d2&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-068d10d2"]])

export default __exports__